import React, { useState, useEffect } from "react";
import "./style.scss";
import { EditOutlined } from "@ant-design/icons";
import { Layout, Space, Button, PageHeader, Card, Row, Col } from "antd";
import R2Footer from "../../components/Footer";
import TestimonialService from "../../services/TestimonialService";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AddAndUpdateRestaurant from "./AddAndUpdateRestaurant";
import Dummy_icon from "../../assets/images/FoodLuv_Empty.png";


const { Content } = Layout;

const Myrestaurants = (props) => {
  const [addModal, setAddModal] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [updatedRestaurant, setUpdatedTestimonial] = useState();
  const [restaurants, setRestaurants] = useState([]);

  useEffect(() => {
    getRestaurants();
  }, []);

  const createRestaurant = (status) => {
    setAddModal(status);
    getRestaurants();
  };

  const getRestaurants = async () => {
    const data = await TestimonialService.getRestaurant();
    setRestaurants(data.restaurants);
  };
  

  return (
    <>
      {!addModal && (
        <Layout className="u-page-layout">
          <Content className="page-padding">
            <Space
              direction="vertical"
              style={{
                width: "100%",
              }}
            >
              <PageHeader
              className="page-header-business"
                title="My Resturants"
                style={{ background: "#f0f2f5" }}
                extra={[
                  <Button
                    type="primary"
                    className="custom-btn"
                    onClick={() => {
                      setEdit(false);
                      setAddModal(true);
                    }}
                  >
                    Add Restaurant
                  </Button>,
                ]}
              />
              <div className="grid-restaurant-container content-container-business">
                <Row gutter={[16,16]}>
                {restaurants.map((item) => (
                  <Col>
                  <Card
                    bordered={false}
                    style={{
                      width: 360,
                      borderRadius: "7px",
                    }}
                    cover={<img alt="logo" src={item?.logo_url ?? Dummy_icon} height={190} />}
                  >
                    <div className="restaurant-card-body">
                      <div>{item?.name}</div>
                      <div>{item?.address}</div>
                      <div>
                        <div>{item?.phone}</div>
                        <EditOutlined
                          onClick={() => {
                            setUpdatedTestimonial(item);
                            setEdit(true);
                            setAddModal(true);
                          }}
                        />
                      </div>
                    </div>
                  </Card>
                  </Col>
                ))}
                </Row>
              </div>
            </Space>
          </Content>
          <R2Footer />
        </Layout>
      )}
      {/* {addModal && (
        <AddRestaurant
          modalOpen={true}
          isEdit={isEdit}
          closeModal={closeModal}
          updatedRestaurant={updatedRestaurant}
        />
      )} */}
      {addModal && (
        <AddAndUpdateRestaurant
          closeModal={setAddModal}
          isEdit={isEdit}
          editRestaurantData={updatedRestaurant}
          createRestaurant = {createRestaurant}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    adminRestaurant: state.admin,
  };
};
export default withRouter(connect(mapStateToProps)(Myrestaurants));
